<template>
    <div class="flex-1">
        <skeleton v-if="plan === undefined" />
        <div v-else-if="plan === null">
            Whoops! We could not find that plan at this facility.
        </div>
        <purchase-agreement
            v-else
            :plan="plan"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import PurchaseAgreement from '~/components/PurchaseContract/Agreement/PurchaseAgreement.vue'
import { useQuery } from '@tanstack/vue-query'
import { useRpQuery } from '~/composables/graphql'
import { graphql } from '~/resources/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'
import Skeleton from 'primevue/skeleton'
import { useCurrentDate } from '~/composables/use-current-date'
import { usePurchaseAgreement } from '~/components/PurchaseContract/Agreement/use-purchase-agreement'

const props = defineProps<{ planId: string }>()
const planId = computed(() => props.planId)
const activeFacility = useActiveFacility()
const activeFacilityId = computed(() => activeFacility.value.id)

const currentDate = useCurrentDate()
const reactiveDate = computed(() => currentDate.value.getDate())
const query = useRpQuery()
const { data } = useQuery({
    queryKey: [
        'PurchaseAgreementWrapperQuery',
        planId,
        activeFacilityId,
        reactiveDate
    ],
    queryFn: () =>
        query(
            graphql(/* GraphQL */ `
                query PurchaseAgreementWrapperQuery($planId: ID!) {
                    plan(id: $planId) {
                        terms {
                            language
                        }
                    }
                }
            `),
            {
                planId: planId.value
            }
        )
})

const purchaseAgreementInput = computed(() => {
    if (data.value === undefined) {
        return undefined
    }

    if (data.value.plan === null) {
        return null
    }

    return {
        planId: planId.value,
        language: data.value.plan.terms.language
    }
})
const { plan } = usePurchaseAgreement(purchaseAgreementInput)
</script>
